module.exports = "<div class=\"ot-notification\">\n  <p ng-class=\"{'ot-important': params.type=='important', 'ot-warning': params.type=='warning', 'ot-success': params.type=='success','ot-full': params.type=='fulldinner','ot-full': params.type=='rejecteddinner'}\">{{params.text | translate}}</p>\n</div>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/templates/directives/content/notification.html
 ** module id = 271
 ** module chunks = 1
 **/